import { Flex } from 'antd'
import { useIsAdmin } from '../../../redux/slices/session'
import { ListError, PageHeader } from '../../Common'
import CyclesFilter from '../../Common/CyclesFilter'
import usePracticeCycles from '../../Common/usePracticeCycles'
import Filters, { FIELDS_OPTIONS } from '../../Forms/Filters'
import { PAGE_SIZE } from '../../../lib/constants'
import useFilters from '../../Cycles/useFilters'
import BillingOrders from './BillingOrders'

const DEFAULT_FILTERS = {
  query: '',
  page: 1,
  perPage: PAGE_SIZE,
  billed: FIELDS_OPTIONS.billed[0].id,
  showInactive: false,
}

export default function PracticeBillingOrders() {
  const isAdmin = useIsAdmin()
  const [
    { error, pendingCycles, clearError },
    { practice, pending, practiceId },
  ] = usePracticeCycles()

  const {
    handleFilterChange,
    handlePageChange,
    conditions,
    setConditions,
  } = useFilters(DEFAULT_FILTERS, { defaultToPrevCycle: 'always' })

  const { cycleId, page, query, billed, showInactive } = conditions

  if (cycleId && !pending && !pendingCycles) {
    return (
      <div>
        <PageHeader
          title="Remote Billing Orders"
          subTitle={isAdmin && practice.name}
        />
        <Flex gap={10}>
          <CyclesFilter
            practiceId={practiceId}
            onSubmit={({ cycleId: newCycleId }) =>
              handleFilterChange({ cycleId: newCycleId })
            }
            currentCycleId={cycleId}
          />
          <Filters
            defaultValues={DEFAULT_FILTERS}
            currentValues={conditions}
            onSubmit={({
              query: newQuery,
              billed: newBilled,
              showInactive: newShowInactive,
            }) =>
              setConditions({
                ...conditions,
                query: newQuery,
                billed: newBilled,
                showInactive: newShowInactive || undefined,
                page: 1,
              })
            }
            placeholders={{
              query: 'Search by Name, DOB(YYYY-MM-DD), or MRN',
              billed: 'Billed status',
            }}
            showSearch
            showBilledStatus
            showInactiveCheck
          />
        </Flex>
        <BillingOrders
          cycleId={cycleId}
          onPageChange={handlePageChange}
          page={page}
          query={query}
          billed={billed}
          showInactive={showInactive}
          practiceId={practiceId}
        />
      </div>
    )
  }

  return (
    <div>
      {error && <ListError description={error.message} onClose={clearError} />}
    </div>
  )
}
